import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
  justify-content: center;
  width: 100%;

  .content-share {
    height: calc(100% - 240px);
  }

  @media screen and (min-width: 1440px) {
    .content-share {
      height: calc(100% - 210px);
    }
  }

  @media screen and (min-width: 1920px) {
    .content-share {
      height: calc(100% - 240px);
    }
  }
`;
